import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView";
import HomeViewZH from "../views/zh/HomeView";
import Base64 from "../views/Base64";
import Base64ZH from "../views/zh/Base64";
import JSONFormatter from "../views/JSONFormatter";
import JSONFormatterZH from "../views/zh/JSONFormatter";
import Timestamp from "../views/Timestamp";
import TimestampZH from "../views/zh/Timestamp";
import Uuid from "../views/Uuid";
import UuidZH from "../views/zh/Uuid";
import QRcode from "../views/QrCode"
import QRcodeZH from "../views/zh/QrCode"
import Cropper from "../views/Cropper"
import CropperZH from "../views/zh/Cropper"
import UrlCode from "../views/UrlCode"
import UrlCodeZH from "../views/zh/UrlCode"
import Password from "../views/Password"
import PasswordZH from "../views/zh/Password"
import MarkdownZH from "../views/zh/Markdown"
import Markdown from "../views/Markdown"
import Excel2JSONZH from "../views/zh/Excel2JSON"
import Excel2JSON from "../views/Excel2JSON"
import ExcelZH from "../views/zh/Excel"
import Excel from "../views/Excel"
import CaseConversion from "../views/CaseConversion"
import Ip from "../views/Ip.vue"
import IpZH from "../views/zh/Ip.vue"
import Blog from "../views/Blog.vue"
import BlogZH from "../views/zh/Blog.vue"
import BlogDetailZH from "../views/zh/BlogDetail.vue"
import CountDown from "../views/zh/CountDown.vue"
import RandomName from "../views/RandomName.vue"
import RandomNameZH from "../views/zh/RandomName.vue"
import Upload from "../views/Upload.vue"
import ColorConverter from "../views/ColorConverter.vue"
import ColorConverterZH from "../views/zh/ColorConverter.vue"
import TextDiff from "../views/TextDiff.vue"
import TextDiffZH from "../views/zh/TextDiff.vue"
import CodeBeautifier from "../views/CodeBeautifier.vue"
import CodeBeautifierZH from "../views/zh/CodeBeautifier.vue"
import ImageCompressor from "../views/ImageCompressor.vue"
import ImageCompressorZH from "../views/zh/ImageCompressor.vue"

import Privacy from "../views/Privacy";
import Terms from "../views/Terms";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/zh",
      name: "homeZH",
      component: HomeViewZH,
    },
    {
      path: "/base64",
      name: "base64",
      component: Base64,
    },
    {
      path: "/zh/base64",
      name: "Base64ZH",
      component: Base64ZH,
    },
    {
      path: "/json",
      name: "json",
      component: JSONFormatter,
    },
    {
      path: "/zh/json",
      name: "jsonZH",
      component: JSONFormatterZH,
    },
    {
      path: "/timestamp",
      name: "timestamp",
      component: Timestamp,
    },
    {
      path: "/zh/timestamp",
      name: "TimestampZH",
      component: TimestampZH,
    },
    {
      path: "/uuid",
      name: "uuid",
      component: Uuid,
    },
    {
      path: "/zh/uuid",
      name: "UuidZH",
      component: UuidZH,
    },
    {
      path: "/qrcode",
      name: "qrcode",
      component: QRcode,
    },
    {
      path: "/zh/qrcode",
      name: "qrcodeZH",
      component: QRcodeZH,
    },
    {
      path: "/cropper",
      name: "cropper",
      component: Cropper,
    },
    {
      path: "/zh/cropper",
      name: "cropperZH",
      component: CropperZH,
    },
    {
      path: "/urlencode",
      name: "urlencode",
      component: UrlCode,
    },
    {
      path: "/zh/urlencode",
      name: "UrlCodeZH",
      component: UrlCodeZH,
    },
    {
      path: "/password",
      name: "password",
      component: Password,
    },
    {
      path: "/zh/password",
      name: "PasswordZH",
      component: PasswordZH,
    },
    {
      path: "/zh/markdown",
      name: "MarkdownZH",
      component: MarkdownZH,
    },
    {
      path: "/markdown",
      name: "Markdown",
      component: Markdown,
    },
    {
      path: "/zh/excel2json",
      name: "Excel2JSONZH",
      component: Excel2JSONZH,
    },
    {
      path: "/excel2json",
      name: "Excel2JSON",
      component: Excel2JSON,
    },
    {
      path: "/zh/Excel",
      name: "ExcelZH",
      component: ExcelZH,
    },
    {
      path: "/Excel",
      name: "Excel",
      component: Excel,
    },
    {
      path: "/CaseConversion",
      name: "CaseConversion",
      component: CaseConversion,
    },
    {
      path: "/ip",
      name: "Ip",
      component: Ip,
    },
    {
      path: "/zh/ip",
      name: "IpZH",
      component: IpZH,
    },
    {
      path: "/blog",
      name: "Blog",
      component: Blog,
    },
    {
      path: "/zh/blog",
      name: "BlogZH",
      component: BlogZH,
    },
    {
      path: "/zh/blogDetail",
      name: "BlogDetailZH",
      component: BlogDetailZH,
    },
    {
      path: "/zh/countDown",
      name: "CountDown",
      component: CountDown,
    },
    {
      path: "/randomName",
      name: "RandomName",
      component: RandomName,
    },
    {
      path: "/zh/randomName",
      name: "RandomNameZH",
      component: RandomNameZH,
    },
    {
      path: "/upload",
      name: "Upload",
      component: Upload,
    },
    {
      path: "/regexp",
      name: "RegExpTester",
      component: () => import("../views/RegExpTester.vue"),
      meta: {
        title: "RegExp Tester"
      }
    },
    {
      path: "/zh/regexp",
      name: "RegExpTesterZH",
      component: () => import("../views/zh/RegExpTester.vue"),
      meta: {
        title: "正则表达式测试工具"
      }
    },
    {
      path: "/color",
      name: "ColorConverter",
      component: ColorConverter,
      meta: {
        title: "Color Converter"
      }
    },
    {
      path: "/zh/color",
      name: "ColorConverterZH",
      component: ColorConverterZH,
      meta: {
        title: "颜色转换工具"
      }
    },
    {
      path: "/textdiff",
      name: "TextDiff",
      component: TextDiff,
      meta: {
        title: "Text Diff Tool"
      }
    },
    {
      path: "/zh/textdiff",
      name: "TextDiffZH",
      component: TextDiffZH,
      meta: {
        title: "文本对比工具"
      }
    },
    {
      path: "/code-beautifier",
      name: "code-beautifier",
      component: () => import("../views/CodeBeautifier.vue"),
      meta: {
        title: "Code Beautifier",
        icon: "icon-code",
        group: "development"
      }
    },
    {
      path: "/zh/code-beautifier",
      name: "CodeBeautifierZH",
      component: CodeBeautifierZH,
      meta: {
        title: "代码美化工具"
      }
    },
    {
      path: "/image-compressor",
      name: "ImageCompressor",
      component: ImageCompressor,
      meta: {
        title: "Image Compressor",
        icon: "icon-image",
        group: "tools"
      }
    },
    {
      path: "/zh/image-compressor",
      name: "ImageCompressorZH",
      component: ImageCompressorZH,
      meta: {
        title: "图片压缩工具"
      }
    },

    {
      path: "/privacy",
      name: "privacy",
      component: Privacy,
      meta: {
        title: "Privacy Policy - DevOnlineTools",
        description: "Privacy Policy for DevOnlineTools - Your trusted online developer tools"
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms,
      meta: {
        title: "Terms of Service - DevOnlineTools",
        description: "Terms of Service for DevOnlineTools - Your trusted online developer tools"
      }
    },
    {
      path: "/zh/privacy",
      name: "privacyZH",
      component: Privacy,
      meta: {
        title: "隐私政策 - DevOnlineTools",
        description: "DevOnlineTools隐私政策 - 您信赖的在线开发者工具"
      }
    },
    {
      path: "/zh/terms",
      name: "termsZH",
      component: Terms,
      meta: {
        title: "服务条款 - DevOnlineTools",
        description: "DevOnlineTools服务条款 - 您信赖的在线开发者工具"
      }
    },
  ],
});

export default router;
